<div class="content-wrapper">

  <section class="content-header">
    <h1>
      Repasses
      <small>Criar, listar e editar</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="/home">
          <i class="fa fa-home"></i> Home</a>
      </li>
      <li class="active">Repasses</li>
    </ol>
  </section>

  <br>

  <div class="col-md-12">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">Gerenciar conteúdo</h3>
      </div>

      <br>

      <div class="box-body no-padding">

        <form autocomplete="off">
          <div class="col-md-5">
            <div class="form-group">
              <label for="imput1">Entidade:</label>
              <input type="email" class="form-control" id="imput1" placeholder="Entidade">
            </div>
          </div>
          <div class="col-md-5">
            <div class="form-group">
              <label for="imput2">N° do convênio/parceria:</label>
              <input type="email" class="form-control" id="imput2" placeholder="Número">
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <div class="radio">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" value="option1"> Proposta
                </label>
                &nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" value="option2"> Vigentes
                </label>
                &nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios3" value="option3"> Encerrados
                </label>
                &nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios4" value="option4"> T. aditivo
                </label>
                &nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios5" value="option5"> Rescindido
                </label>
                &nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios6" value="option6" checked> Todos
                </label>
              </div>
            </div>

          </div>
          <div class="col-md-12">
            <hr>
            <button type="submit" class="btn btn-primary ">
              Consultar</button>
          </div>
                    <div class="form-group col-sm-12 no-padding" style="margin-top: 8px;">
                <label class="checkbox-inline">
                    <input type="checkbox" [(ngModel)]="manterFiltrosSelecionados" name="manterFiltrosSelecionados"
                        (ngModelChange)="alterarManterFiltrosSelecionados($event)">
                    Manter filtros selecionados
                </label>
            </div></form>

        <div class="col-md-12">
          <hr>
        </div>

        <!-- <div class="col-md-12">
          <p-dataTable [value]="dados" [responsive]="true" emptyMessage="Nenhum registro encontrado." [paginator]="filtro" [rows]="8"
            [lazy]="true" [totalRecords]="totalRegistros" #tabela>

            <p-column header="Concedente/Estado"></p-column>
            <p-column header="Proponente"></p-column>
            <p-column header="Objeto"></p-column>
            <p-column styleClass="col-acoes" header="Ações">
              <ng-template let-edit="rowData" pTemplate="body"></ng-template>
            </p-column>

          </p-dataTable>
        </div> -->


        <div class="col-xs-12">
          <div class="box no-padding">
              <div class="box-header">
                  <h3 class="box-title">Listagem</h3>

                  <div class="box-tools">
                      <div class="input-group input-group-sm" style="width: 300px;">
                          <input type="text" name="table_search" class="form-control pull-right" placeholder="Pesquisar">

                          <div class="input-group-btn">
                              <button type="submit" class="btn btn-default">
                                  <i class="fa fa-search"></i>
                              </button>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- /.box-header -->
              <div class="box-body table-responsive no-padding">
                  <table class="table table-hover">
                      <tbody>
                          <tr>
                              <th>Concedente/Estado</th>
                              <th>Proponente</th>
                              <th>Objeto</th>
                          </tr>
                          <tr [routerLink]="['/#', 1]" style="cursor: pointer;" >
                              <td>Entidade Concedente 001 / Piauí</td>
                              <td>Entidade proponente 001</td>
                              <td>Quod autem magnum dolorem brevem, longinquum levem esse dicitis, id non intellego quale sit. Quamquam ab iis philosophiam et omnes ingenuas disciplinas habemus</td>
                          </tr>
                          <tr [routerLink]="['/#', 1]" style="cursor: pointer;" >
                              <td>Concedente 191 / Piauí</td>
                              <td>Entidade proponente 002</td>
                              <td>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mihi quidem Antiochum, quem audis, satis belle videris attendere. Philosophi autem in suis lectulis plerumque moriuntur.</td>
                          </tr>

                      </tbody>
                  </table>
              </div>
              <!-- /.box-body -->
          </div>
      </div>


      </div>

      <br>
      <div class="box-footer clearfix"></div>

    </div>

  </div>